import React, { useState, useEffect } from "react";
import axios from "axios";
import { FileCopy } from "@material-ui/icons";
import { dateFormatter } from "../../../components/DtFormatter";
import TaxUpdate from "./TaxUpdate";
import ExportTaxTemp from "./TaxTempExport";
import Cookies from "universal-cookie";
const cookies = new Cookies();


export default function TaxBracket() {
  const permissions = cookies.get("permissions")["config"];
  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [recordsPerPage, setRecordsPerPage] = useState(10);
  const [filteredData, setFilteredData] = useState([]);
  const [fileLoaded, setFileLoaded] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      let apiLink = "api/tax_bracket";
      const res = await axios.get(apiLink);
      setData(res.data);
      setFilteredData(res.data);
    };

    if (!fileLoaded) {
      fetchData();
      setFileLoaded(true);
    }
  });

  const handleAddCallback = (editData) => {
    if (editData) {
      setFileLoaded(false);
    }
  };

  const pages = [];
  for (let i = 1; i <= Math.ceil(filteredData.length / recordsPerPage); i++) {
    pages.push(i);
  }

  const handleRecordPerPage = (e) => {
    console.log(e.target.value);
    setRecordsPerPage(parseInt(e.target.value));
    setCurrentPage(1);
  };

  const handleSearch = (e) => {
    const filterer = data.filter(function (data) {
      for (var key in data) {
        if (
          !data["name"].toLowerCase().includes(e.target.value.toLowerCase())
        ) {
          return false;
        }
        return true;
      }
    });
    setFilteredData(filterer);
  };

  const startIndex = currentPage * recordsPerPage - recordsPerPage;
  const endIndex = startIndex + recordsPerPage;
  const currentData = filteredData.slice(startIndex, endIndex);

  return (
    <div>
      <div className="row mb-3">
        <div className="col-lg-12 col-md-12 col-sm-12">
          {permissions > 1 ? (
            <div className="btn-group float-right">
              <TaxUpdate parentCallback={handleAddCallback} />
              <ExportTaxTemp />
            </div>
          ) : (
            ""
          )}
        </div>
      </div>
      <div className="row">
        <div className="col-sm-12">
          <div className="table-wrap">
            <div className="table-responsive mb-10">
              <table className="table table-sm table-bordered table-striped mb-0">
                <thead className="thead-secondary">
                  <tr className="text-center">
                    <th colSpan="2">Annual Income</th>
                    <th rowSpan="2">Tax Percentage</th>
                    <th rowSpan="2">Fixed Tax Amount</th>
                    <th rowSpan="2">Status</th>
                    <th rowSpan="2" style={{ width: "210px" }}>
                      Date Created
                    </th>
                  </tr>
                  <tr className="text-center">
                    <th>Lower Limit</th>
                    <th>Upper Limit</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredData.length > 0 ? (
                    data.map((tax) => (
                      <tr key={tax.id}>
                        <td className="text-right">
                          {tax.tax_lower_range
                            .toString()
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                        </td>
                        <td className="text-right">
                          {tax.tax_upper_range
                            .toString()
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                        </td>
                        <td className="text-right">
                          {(tax.rate * 100).toFixed(2)} %
                        </td>
                        <td className="text-right">
                          {tax.additional
                            .toString()
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                        </td>
                        <td>
                          <strong
                            className={
                              tax.active == 0 ? "text-danger" : "text-success"
                            }
                          >
                            {tax.active == 0 ? "INACTIVE" : "ACTIVE"}
                          </strong>
                        </td>
                        <td>
                          {dateFormatter(
                            tax.created_at,
                            "MMM dd, yyyy hh:mm aa"
                          )}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="5" className="text-center">
                        No Data to show
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
